export default __webpack_public_path__ + "static/piano-static-0e4a1c0f1271496d945424e36a957410.png";